import { IFileDetails } from '@/types/response/fileDetails';
import { useAppQuery, UseAppQueryOptions } from '.';
import { API_ROUTES } from '@/constants/api-routes';
import queryKeys from '@/constants/queryKeys';

const useGetFileListQuery = (
  envelopeId: string | undefined,
  itemId: number | undefined,
  options?: UseAppQueryOptions<IFileDetails[]>,
) => {
  const queryKey = [queryKeys.GET_FILES_ITEM, envelopeId, itemId];
  return useAppQuery<IFileDetails[]>({
    routeName: API_ROUTES.GET_FILES_ITEM,
    queryKey,
    requestConfig: {
      params: {
        envelopeId: envelopeId,
        itemId: itemId,
      },
    },
    options,
  });
};

export default useGetFileListQuery;
